import { Card, CardBody, Col } from "reactstrap";
import { UL } from "../../../../AbstractElements";
import PrimaryVariation from "./PrimaryVariation";
import SecondaryVariation from "./SecondaryVariation";
import WarningVariation from "./WarningVariation";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { VariationTimelineTitle } from "../../../../Constants/Constants";
import { VariationTimelineSubTitle } from "../../../../Data/BonusUi/Timeline";

const VariationTimeline = () => {
  return (
    <Col xxl="4" xl="5" className="notification box-col-12">
      <Card>
        <CommonCardHeader title={VariationTimelineTitle} span={VariationTimelineSubTitle} />
        <CardBody className="dark-timeline">
          <UL className="simple-list">
            <PrimaryVariation />
            <WarningVariation />
            <SecondaryVariation />
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};
export default VariationTimeline;
